import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AtribucionComponent } from './components/atribucion/atribucion.component';
import { ObjetivosComponent } from './components/objetivos/objetivos.component';
import { PlanAccionComponent } from './components/plan-accion/plan-accion.component';

import { EstrategiasComponent } from './components/estrategias/estrategias.component';
import { ProcesoComponent } from './components/proceso/proceso.component';
 import { ProyectoComponent } from './components/proyecto/proyecto.component';
import { IndicadoresProcesosComponent } from './components/indicadores/indicadores-procesos/indicadores-procesos.component';
import { IndicadoresComponent } from './components/indicadores/indicadores.component';
import { LineaAccionComponent } from './components/linea-accion/linea-accion.component';
import { RiesgosComponent } from './components/riesgos/riesgos.component';
import { VisionComponent } from './components/vision/vision.component';
import { ProcesoPermisionGuard } from './guard/procesoPermision.guard';
import { LineaAccionPermisionGuard } from './guard/lineaAccionPermision.guard';
import { PlanAccionPermisionGuard } from './guard/planesAccionPermision.guard';
import { ProyectoPermisionGuard } from './guard/proyectoPermision.guard';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AccessPermisionGuard } from 'src/app/guard/accessPermision.guard';
const routesAdmin: Routes = [
  {
    path: '',
    //component: PagesComponent,//Ruta protegida: En PagesComponent se renderiza todo lo de estas rutas de abajo
    //canActivate:[AuthGuard],
    children:
    [
      { path: 'vision', component: VisionComponent, data:{title:'Ambientes', apps:[ConstantsCatalogosIdService.VISION_MISION]}, canActivate:[AccessPermisionGuard]},
      { path: 'objetivos', component: ObjetivosComponent, data:{title:'Objetivos', apps:[ConstantsCatalogosIdService.OBJETIVOS_ESTRATEGIAS]}, canActivate:[AccessPermisionGuard]},
      { path: 'indicadores', component: IndicadoresComponent, data:{title:'Indicadores', apps:[ConstantsCatalogosIdService.INDICADORES]}, canActivate:[AccessPermisionGuard]},
      { path: 'linea-accion', component: LineaAccionComponent, data:{title:'linea Acción', apps:[ConstantsCatalogosIdService.LINEAS_ACCION]}, canActivate:[AccessPermisionGuard]},
      { path: 'plan-accion', component: PlanAccionComponent, data:{title:'PLan Acción', apps:[ConstantsCatalogosIdService.PLANES_ACCION]}, canActivate:[AccessPermisionGuard]},
      { path: 'estrategias', component: EstrategiasComponent, data:{title:'Estrategias', apps:[ConstantsCatalogosIdService.OBJETIVOS_ESTRATEGIAS]}, canActivate:[AccessPermisionGuard]},
      { path: 'atribucion', component: AtribucionComponent, data:{title:'Atribución', apps:[ConstantsCatalogosIdService.COMPETENCIAS_ATRIBUCIONES]}, canActivate:[AccessPermisionGuard]},
      { path: 'procesos', component: ProcesoComponent, data:{title:'Procesos', apps:[ConstantsCatalogosIdService.PROCESOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'proyectos', component: ProyectoComponent, data:{title:'ProyectoS', apps:[ConstantsCatalogosIdService.PROYECTOS]}, canActivate:[AccessPermisionGuard]},
      { path: 'riesgos', component: RiesgosComponent, data:{title:'Riesgos', apps:[ConstantsCatalogosIdService.RIESGOS]}, canActivate:[AccessPermisionGuard]},
    ]
  },//Para rutas protegidas

/*   {
    path: '',
    component: IndicadoresComponent,//Ruta protegida: En PagesComponent se renderiza todo lo de estas rutas de abajo
    //canActivate:[AuthGuard],
    children:
    [
      { path: 'indicadores/procesos', component: ProcesosComponent, data:{title:'Proyecto'} },
    ]
  },//Para rutas protegidas */
];


@NgModule({
  imports: [RouterModule.forChild(routesAdmin)],//Para rutas hijas
  exports: [RouterModule]
})

export class ElementosPlanRoutingModule {

}

